import { z } from 'zod';
import { DateSchema } from './base';

export const CellInfoSchema = z
  .object({
    radio: z.enum(['GSM', 'UMTS', 'CDMA', 'LTE', 'NR']),
    mcc: z.number(),
    net: z.number(),
    area: z.number(),
    cell: z.number(),
    unit: z.number().nullish(),
    lon: z.number(),
    lat: z.number(),
    cellRange: z.number(),
    samples: z.number(),
    changeable: z.number(),
    created: DateSchema,
    updated: DateSchema,
    averageSignal: z.number().optional(),
    operator: z.string().nullish(),
    country: z.string().nullish(),
    countryCode: z.string().nullish(),
  })
  .transform((data) => ({
    radio: data.radio,
    mcc: data.mcc,
    mnc: data.net, // Rename net to mnc
    lac: data.area, // Rename area to lac
    cellId: data.cell, // Rename cell to cellId
    unit: data.unit,
    lat: data.lat,
    lng: data.lon, // Rename lon to lng
    range: data.cellRange, // Rename cellRange to range
    samples: data.samples,
    changeable: data.changeable === 1,
    createdAt: data.created,
    updatedAt: data.updated,
    averageSignal: data.averageSignal,
    operator: data.operator,
    country: data.country,
    countryCode: data.countryCode,
  }));

export type CellInfo = z.infer<typeof CellInfoSchema>;

/**
 * What an MCC/MNC pair alone says, for cells the database does not know. `null` fields mean the
 * pair is not in the service's table.
 */
export const CarrierInfoSchema = z.object({
  operator: z.string().nullish(),
  country: z.string().nullish(),
  countryCode: z.string().nullish(),
});

export type CarrierInfo = z.infer<typeof CarrierInfoSchema>;

export const MultipleCellInfosSchema = z.object({
  cells: z.array(CellInfoSchema),
  nextCursor: z.string().optional(),
  hasMore: z.boolean(),
});

export type MultipleCellInfos = z.infer<typeof MultipleCellInfosSchema>;
